import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'
import { Body } from './Body'
import { Header } from './Header'
import { InvalidHeader } from './InvalidHeader'
import { Footer } from './Footer/Footer'
import { InvalidFooter } from './InvalidFooter'
import { InvalidBody } from './InvalidBody'
import { ExportOrderSource } from '..'

type ContentProps = {
  source: ExportOrderSource
}

export function Content({ source }: ContentProps) {
  const { ready, invalid } = useConfigureController(source)

  if (!ready) return null

  if (invalid) {
    return (
      <ModalContent header={<InvalidHeader />} footer={<InvalidFooter />}>
        <InvalidBody />
      </ModalContent>
    )
  }

  return (
    <ModalContent header={<Header />} footer={<Footer />} minWidth={1030}>
      {invalid ? <InvalidBody /> : <Body />}
    </ModalContent>
  )
}
